import CheckCircleIcon from "@mui/icons-material/CheckCircle";

/**
 * Vertical list of checkmark value props, shared across feature sections.
 *
 * @param {Object} props
 * @param {string[]} props.items - bullet strings
 * @param {string} [props.iconClassName] - color class for the check icons, defaults to text-cerulean
 * @param {string} [props.className] - extra classes on the <ul>
 * @returns {import("react").ReactElement}
 */
export function CheckList(props) {
  const { items, iconClassName = "text-cerulean", className = "" } = props;

  return (
    <ul className={`flex flex-col gap-2.5 ${className}`.trim()}>
      {items.map((item) => (
        <li key={item} className="text-ink-soft flex items-start gap-3 text-[15px]">
          <CheckCircleIcon
            className={iconClassName}
            sx={{ fontSize: 20, marginTop: "1px", flexShrink: 0 }}
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
